<template>
  <q-dialog v-model="show" persistent>
    <q-card class="padding-horizontal-medium">
      <q-toolbar>
        <q-toolbar-title><span class="text-weight-bold">Suppression</span> d'une séance <span v-if="seance.is_demo">de démo</span></q-toolbar-title>
        <q-btn flat round dense icon="close" @click="$emit('cancel')" />
      </q-toolbar>

      <q-card-section>
        <div class="text-h6">Voulez-vous supprimer la séance ?</div>
      </q-card-section>


      <q-card-section>
        <p>- Séance de démonstration</p>
        <p>- Code d'accès : {{seance.code_acces}}</p>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn label="Annuler" color="secondary" flat class="q-ml-sm" @click="$emit('cancel')"/>
        <q-btn label="Supprimer" color="red" flat @click="$emit('delete')"/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>
export default {
  name: "DeleteSeance",
  props: {
    show: Boolean,
    seance: Object,
  },
}
</script>
